import './bg.css'
import { useRef, useEffect, useState } from 'react'
import { motion } from 'framer-motion'

export default function BgSlider({ title, subtitle }) {
    const bgRefs = [useRef(null), useRef(null)];
    const [images] = useState([
        `${process.env.PUBLIC_URL}/images/C1.png`,
        `${process.env.PUBLIC_URL}/images/P13.png`,
        `${process.env.PUBLIC_URL}/images/PC30.png`,
    ]);

    useEffect(() => {
        let activeDiv = 0;
        let nextImgIndex = 1;
        const fadeDuration = 1000;
        const displayDuration = 4000;

        bgRefs[0].current.style.backgroundImage = `url(${images[0]})`;
        bgRefs[1].current.style.backgroundImage = `url(${images[1]})`;

        const interval = setInterval(() => {
            const inactiveDiv = activeDiv === 0 ? 1 : 0;
            bgRefs[inactiveDiv].current.style.backgroundImage = `url(${images[nextImgIndex]})`;
            bgRefs[activeDiv].current.classList.remove("visible");
            bgRefs[inactiveDiv].current.classList.add("visible");
            activeDiv = inactiveDiv;
            nextImgIndex = (nextImgIndex + 1) % images.length;
        }, fadeDuration + displayDuration);

        return () => clearInterval(interval);
    }, [images]);

    const textVariant = {
        hidden: { opacity: 0, y: 18 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
    }

    return (
        <div className="cover-container">
            <div ref={bgRefs[0]} className="bg-image visible"></div>
            <div ref={bgRefs[1]} className="bg-image"></div>
            <motion.p
                initial="hidden"
                animate="visible"
                variants={textVariant}
                transition={{ delay: 0.15 }}
            >
                {subtitle}
            </motion.p>
            <motion.h1
                initial="hidden"
                animate="visible"
                variants={textVariant}
                transition={{ delay: 0.3 }}
            >
                {title}
            </motion.h1>
        </div>
    );
}